<template>
  <div class="client-container">
    <a-table
      :pagination="showPagination"
      :columns="tableColumns"
      :data-source="tableDataList"
      :row-selection="rowSelection"
      :scroll="{ x: 800, y: 450 }"
    />

    <a-button
      type="dashed"
      :style="{
        width: '200px',
        height: '40px',
        margin: '15px 10px 0px'
      }"
      @click.stop="closeWin"
    >
      取 消
    </a-button>
    <a-button
      type="primary"
      :style="{
        width: '200px',
        height: '40px',
        margin: '15px 10px 0px'
      }"
      @click.stop="doBindArea"
    >
      绑 定
    </a-button>
  </div>
</template>
<script>
var pageContext;
export default {
  props: {
    itemData: {
      type: Object,
      default: () => {
        return {};
      }
    },
    local: {
      type: String,
      default: "55"
    },
    layerid: {
      type: String,
      default: ""
    },
    lydata: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showPagination: false,
      platform_type: localStorage.getItem("role") == 1 ? "sp" : "cp",
      company_id: localStorage.getItem("companyId"),
      is_admin: localStorage.getItem("is_admin"),
      bindArea: localStorage.getItem("bindArea"),
      tableColumns: [
        {
          title: "名称",
          dataIndex: "name",
          key: "name"
        },
        {
          title: "编号",
          dataIndex: "id",
          key: "id",
          width: "180px"
        },
        {
          title: "排序",
          dataIndex: "sort",
          key: "sort",
          width: "100px"
        }
      ],
      tableDataList: [],
      selectRowKeyList: [],
      rowSelection: {
        type: "radio",
        fixed: true,
        onChange: (selectedRowKeys, selectedRows) => {
          pageContext.selectRowKeyList = selectedRowKeys;
        },
        getCheckboxProps: record => {
          return {
            props: {
              defaultChecked: pageContext.selectRowKeyList.includes(record.id)
            }
          };
        }
      }
    };
  },
  async mounted() {
    pageContext = this;
    pageContext.selectRowKeyList.push(
      pageContext.itemData.data.bindArea.area_id
    );
    pageContext.refreshDataList();
  },
  methods: {
    async refreshDataList() {
      let args = {};
      if (pageContext.is_admin === "1") {
        args.platform_type = pageContext.platform_type;
        args.company_id = pageContext.company_id;
      } else if (pageContext.bindArea !== "0") {
        args.platform_type = pageContext.platform_type;
        args.company_id = pageContext.company_id;
        args.area_limit = pageContext.bindArea;
      } else {
        return;
      }
      pageContext.$http
        .post("/area/getDataList", args)
        .then(function(response) {
          if (
            response.data.status === 1 &&
            response.data.data.data_list.length > 0
          ) {
            pageContext.tableDataList = response.data.data.data_list;
          }
        })
        .catch(function(error) {
          pageContext.$message.error("请求异常，请检查");
          console.log(error);
        });
    },
    async doBindArea() {
      pageContext.$http
        .post("/Promoter/bindArea", {
          id: pageContext.itemData.id,
          platform_type: pageContext.platform_type,
          company_id: pageContext.company_id,
          area_bind: pageContext.selectRowKeyList
        })
        .then(function(response) {
          if (response.data.status === 1) {
            pageContext.$parent.refreshDataList();
            pageContext.$message.success(response.data.msg);
            pageContext.$layer.close(pageContext.layerid);
          }
        })
        .catch(function(error) {
          pageContext.$message.error("请求异常，请检查");
          console.log(error);
        });
    },
    closeWin() {
      pageContext.$message.info("操作取消");
      pageContext.$layer.close(pageContext.layerid);
    }
  }
};
</script>
<style lang="scss" scoped>
.client-container {
  width: 100%;

  .ant-btn-circle {
    margin: 0px 5px;
  }

  .ant-form {
    display: flex;
  }
}
</style>
